<template>
  <div>
    <page-layout>
      <div class="container">
        <h1>Contact Us</h1>
        <div v-if="!showConfirmView">
          <p>Please complete the field below to leave a message.</p>
          <form name="contact" method="post">
            <error :errors="errors" class="margin-bottom"></error>
            <div class="form-group">
              <label>Message</label>
              <textarea class="form-control message" name="message" v-model="form.message"></textarea>
            </div>
            <button class="btn btn-primary" @click.prevent="submit()" :disabled="!canSubmit">{{ canSubmit ? 'Submit' : 'Submitting...'}}</button>
          </form>
        </div>
        <div v-if="showConfirmView">
          <p class="text-lg">Thanks! Your message has been submitted.</p>
          <p class="text-lg">We'll contact you shortly.</p>
          <router-link class="btn btn-primary" :to="{name: 'dashboard'}">Continue</router-link>
        </div>
      </div>
    </page-layout>
  </div>
</template>

<script>
import PageLayout from '@/components/PageLayout.vue';
import Error from '@/components/Error.vue';
import Http from '@/lib/http';

export default {
  name: 'contact',
  components: {
    PageLayout,
    Error,
  },
  props: {},
  data() {
    return {
      showConfirmView: false,
      canSubmit: true,
      errors: [],
      form: {
        message: null,
      },
    };
  },
  methods: {
    submit() {
      this.errors = [];

      if (!this.form.message) {
        this.errors.push('Please enter your message.');
      }

      if (this.errors.length) {
        return;
      }

      this.canSubmit = false;
      Http.post('leads/main/contact', this.form).then((response) => {
        this.canSubmit = true;
        if (response.data) {
          this.showConfirmView = true;
        }
      }).catch((error) => {
        this.canSubmit = true;
        if (error.response) {
          this.errors.push(error.response.data.error.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.message {
  height: 200px;
}
</style>
